import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home/Home';
import Form from './pages/Form/Form';
import PrivateForm from './pages/PrivateForm/PrivateForm';
import SubmissionSuccess from './components/SubmissionSuccess/SubmissionSuccess';
import PrivateFormValidator from './components/PrivateFormValidator/PrivateFormValidator';
import InvalidToken from './components/InvalidToken/InvalidToken';
import Footer from './components/Footer/Footer';
import About from './pages/About/About';
import Terms from './pages/Terms/Terms';
import Privacy from './pages/Privacy/Privacy';
import IntellectualProperty from './pages/IntellectualProperty/IntellectualProperty';
import PrivateSubmissionSuccess from './components/PrivateSubmissionSuccess/PrivateSubmissionSuccess';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminDashboard from './pages/Admin/AdminDashboard';
import './i18n';
import './styles/App.css';

function App() {
  const [showForm, setShowForm] = useState(false);
  const [isCountdownExpired, setIsCountdownExpired] = useState(false);
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  // Resetear la posición del scroll al cambiar de ruta
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Verificar si el contador ya expiró al cargar
  useEffect(() => {
    const targetDate = new Date("April 30, 2026 00:00:00").getTime();
    const now = new Date().getTime();
    if (now >= targetDate) {
      setIsCountdownExpired(true);
    }
  }, []);

  const handleJoinClick = () => {
    if (isCountdownExpired) {
      return; // No mostrar el formulario si el contador expiró
    }
    setShowForm(true);
    setTimeout(() => {
      document.getElementById('joinForm')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleCountdownExpired = (expired) => {
    setIsCountdownExpired(expired);
    if (expired) {
      setShowForm(false); // Ocultar el formulario si está visible
    }
  };

  // Verificar si estamos en una ruta que debe mostrar solo su contenido
  const isStandaloneRoute = location.pathname.includes('/private-form') || 
                           location.pathname === '/invalid-token' ||
                           location.pathname.includes('/submission-success') ||
                           location.pathname === '/about' ||
                           location.pathname === '/terms' ||
                           location.pathname === '/privacy' ||
                           location.pathname === '/private-submission-success';

  const isFooterProminent = ['/about', '/terms', '/privacy'].includes(location.pathname);

  return (
    <div className={`app-wrapper ${isFooterProminent ? 'with-prominent-footer' : ''}`}>
      <div className="content-wrapper">
        {!isStandaloneRoute && (
          <>
            <Home onJoinClick={handleJoinClick} isExpired={isCountdownExpired} onCountdownExpired={handleCountdownExpired} />
            {showForm && !isCountdownExpired && <Form />}
          </>
        )}
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/intellectual-property" element={<IntellectualProperty />} />
          <Route path="/submission-success" element={<SubmissionSuccess />} />
          <Route path="/private-form/:token" element={<PrivateFormValidator />} />
          <Route path="/private-form-content/:token" element={<PrivateForm />} />
          <Route path="/invalid-token" element={<InvalidToken />} />
          <Route path="/private-submission-success" element={<PrivateSubmissionSuccess />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </div>
      <Footer className={isFooterProminent ? 'prominent-footer' : ''} />
    </div>
  );
}

export default App;
